import { render, staticRenderFns } from "./business-contract.vue?vue&type=template&id=475edfb4&scoped=true&"
import script from "./business-contract.vue?vue&type=script&lang=js&"
export * from "./business-contract.vue?vue&type=script&lang=js&"
import style0 from "./business-contract.vue?vue&type=style&index=0&id=475edfb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475edfb4",
  null
  
)

export default component.exports